<template>
  <div :class="['api-grid']" v-if="api" id="api-grid">
    <example-title :title="$parent.getLangKey('documentationAndApi')" />
    <div :class="['vc-table-layout']" v-if="dropdownItems.length > 1">
      <div>
        <div>
          <!--<h4 :class="[h4, 'align-left']">Documentation for <code>&lt;{{ dropdown[0].value }} /&gt;</code></h4>-->
        </div>
        <div :class="['align-right']">
          <vc-select :items="dropdownItems" :disabled="dropdownItems.length === 1" :color="categoryColor" v-model="dropdown" name="api-grid"></vc-select>
        </div>
      </div>
    </div>
    <vc-tabstrip :tab-height="tabHeight" :name="name" :color="categoryColor" slider-color="white">
      <vc-tabstrip-pane :icon="icons[tab]" v-for="(tab, index) in api.tabs" :key="index" :label="tab">
        <table :class="['vc', 'vc-table', 'elevation-1']" v-if="trs[tab]">
          <thead :class="['grey', 'l-400']">
            <tr>
              <th v-for="(thead, index) in theads[tab]" :key="index" :class="['caption', 'font-grey', 'font-l-900', 'uppercase']" v-html="thead" />
            </tr>
          </thead>
          <tbody>
            <template v-for="(tr, index) in trs[tab]">
              <tr :key="`${index}-top`">
                <td v-for="(td, indexTd) in tr" :key="indexTd" v-if="indexTd < tr.length - 1">
                  <code v-if="indexTd === 3">
                    <span v-if="typeof td === 'string'">"{{ td }}"</span>
                    <span v-else v-html="td" />
                  </code>
                  <code v-else>
                    <span v-html="td" />
                  </code>
                </td>
              </tr>
              <tr :key="`${index}-bottom`">
                <td :colspan="trs[tab][0].length - 1" :class="['caption']">
                  {{ trs[tab][index][trs[tab][0].length - 1] }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <h4 v-else :class="h4" v-html="$parent.getLangKey('noDocumentationAvailable')" />
      </vc-tabstrip-pane>
    </vc-tabstrip>
  </div>
</template>
<script>
export default {
  name: 'ApiGrid',
  data () {
    return {
      api: null,
      name: this.$route.name,
      dropdownItems: [],
      dropdown: null,
      tabHeight: 0,
      trs: [],
      icons: {
        props: 'view_list',
        slots: 'featured_play_list',
        events: 'event',
        functions: 'mdi-function'
      },
      h4: [
        'body-2',
        'font-grey',
        'font-l-600',
        'align-center'
      ],
      theads: {
        props: [
          'Name',
          'Type',
          'Required',
          'Default'
        ],
        slots: [
          'Name'
        ],
        events: [
          'Name',
          'Returns'
        ],
        functions: [
          'Name',
          'Signature'
        ]
      }
    }
  },
  computed: {
    categoryColor () {
      return this.$store.getters.categoryColor
    }
  },
  watch: {
    dropdown () {
      this.trs = this.api.components[this.dropdown[0].value] || []
    },
    api () {
      const dropdownItems = []
      Object.keys(this.api.components).forEach(item => {
        dropdownItems.push({
          label: item,
          value: item
        })
      })
      this.dropdownItems = dropdownItems
      this.dropdown = [dropdownItems[0]]
    }
  }
}
</script>
<style>
.vc-table td,
.vc-table th
{
  border: solid 1px #bdbdbd;
  padding: 8px;
  vertical-align: middle;
}

.api-grid .vc-table tbody tr:nth-child(4n),
.api-grid .vc-table tbody tr:nth-child(4n-1)
{
  background: #eee;
}

.api-grid
{
  margin: 16px 0;
}

.api-grid .vc-table
{
  width: 100%;
  border-collapse: collapse;
}

.api-grid .vc-tabstrip .vc-tabstrip-panes > ul > li
{
  padding: 0;
}

.api-grid .api-grid .vc-table
{
  margin: 16px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/api-grid/ApiGrid.vue